import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './init-flow.reducer';

export const selectProjectState = createFeatureSelector<State>(featureKey);

export const getInitFlow = createSelector(selectProjectState, (state: State) => state.initFlow);
